import styles from "./style.module.scss";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import userImage from "../../../assets/images/user";
import { useSelector } from "react-redux";
import { CheckOutlined } from "@ant-design/icons";
import CreditzIcon from "../../../assets/images/creditz/creditz";
import Connections from "../../../assets/images/creditz/connections";
import ArrowLeft from "../../../assets/images/arrowleft";

const LeftSideComponent = ({
  currentUser,
  history,
  pending,
  pendingConnections = 0
}) => {
  const { creditzIds = [] } = useSelector((state) => ({
    creditzIds: state.profile.creditzIds,
  }));

  const goToCreditz = () => {
    history.push("/creditz");
  };

  const goToConnections = () => {
    history.push("/creditz/connections");
  };
  return (
    <div className={styles.leftSideComponent}>
      <div
        className={styles.avatarContainer}
        style={
          currentUser.coverImageUrl
            ? { backgroundImage: `url(${currentUser.coverImageUrl})` }
            : {}
        }
      />
      <div className={styles.thumb}>
        <img src={currentUser?.profileImageUrl || userImage()} alt="userImage" />
        {currentUser.isVerified && (
          <div className={styles.selected}>
            <CheckOutlined style={{ color: "#C86DD7" }} />
          </div>
        )}
      </div>
      <div className={styles.infoContainer}>
        <p className={styles.name}>{currentUser.username}</p>
        <div className={styles.role}>
          <span>{currentUser.accountType}</span>
        </div>
        <div className={styles.buttons}>
          <div className={styles.button} onClick={() => goToCreditz()}>
            <div className={styles.iconContainer}>
              <div className={styles.iconContainer1}>
                <CreditzIcon />
              </div>
            </div>
            ({pending})Creditz Updates
            <div className={styles.arrowConainer}>
              <ArrowLeft />
            </div>
          </div>
          <div className={styles.button} onClick={() => goToConnections()}>
            <div className={styles.iconContainer}>
              <div className={styles.iconContainer1}>
                <Connections />
              </div>
            </div>
            ({pendingConnections})Connection Updates
            <div className={styles.arrowConainer}>
              <ArrowLeft />
            </div>
          </div>
          {/*
              <div className={styles.button}>
                <div className={styles.iconContainer}>
                  <div className={styles.iconContainer1}>
                    <Opportunity />
                  </div>
                </div>
                (1)Opportunity Updates
                <div className={styles.arrowConainer}>
                  <ArrowLeft />
                </div>
              </div>
              */}
        </div>
      </div>
    </div>
  );
};

LeftSideComponent.propTypes = {
  showProfile: PropTypes.bool,
  currentUser: PropTypes.object,
  history: PropTypes.object,
  pending: PropTypes.number,
  pendingConnections: PropTypes.number,
};

export default withRouter(LeftSideComponent);
